import React, { useMemo, useState } from "react";
import {
  Button,
  Card,
  CardContent,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
} from "@material-ui/core";
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import PowerOffIcon from '@material-ui/icons/PowerOff';
import FlashOnIcon from '@material-ui/icons/FlashOn';
import SettingsIcon from '@material-ui/icons/Settings';
import VolumeOffIcon from '@material-ui/icons/VolumeOff';
import NatureIcon from '@material-ui/icons/Nature';
import OpacityIcon from '@material-ui/icons/Opacity';

export default function TurnOnOffModal(props) {
  const { key, isLoading = false, handleSubmitModalCommand = () => { }, commandDetails = {}, actionDialog = "", series_type = "" } = props?.globalModal.data || {};
  const [selectedValue, setSelectedValue] = useState("");

  const handleSubmit = () => {
    const request = { ...commandDetails };
    const dataKey = actionDialog === "TURN_ON_OFF" ? "switch" : actionDialog === "DISINFECTION" ? "disinfection" : "mode";
    request.packet[1][dataKey] = selectedValue;
    handleSubmitModalCommand(key, request);
    props.closeModal();
  }

  const options = useMemo(() => {
    if (actionDialog === "TURN_ON_OFF") {
      return [
        { value: 0, label: "Turn Off", icon: <PowerOffIcon /> },
        { value: 1, label: "Turn On", icon: <PowerSettingsNewIcon /> }
      ];
    } else if (actionDialog === "DISINFECTION") {
      return [
        { value: 0, label: "Turn Off", icon: <PowerOffIcon /> },
        { value: 1, label: "Turn On", icon: <OpacityIcon /> }
      ];
    } else if (actionDialog === "SET_MODES") {
      const options = [
        { value: 0, label: "Boost Mode", icon: <FlashOnIcon /> },
        { value: 1, label: "Standard Mode", icon: <SettingsIcon /> },
        { value: 3, label: "Eco Mode", icon: <NatureIcon /> }
      ]
      return series_type === "pro" || series_type === "ultra" ? [...options, { value: 2, label: "Silent Mode", icon: <VolumeOffIcon /> }] : options;
    } else {
      return [];
    }
  }, [actionDialog])

  return (
    <>
      <DialogTitle className="heat_pump_modal_title">
        <Grid item md={12} className="d-flex align-items-center con-space-between gap-2">
          <span className="multi-site-head">{actionDialog === "TURN_ON_OFF" || actionDialog === "DISINFECTION" ? "Select the Status" : "Select the Mode"}</span>
        </Grid>
      </DialogTitle>

      <DialogContent dividers className="heat_pump_dialog_content">
        {/* Options */}
        <Grid item md={12} className="">
          <List dense className="heat_pump_dialog_content_list device-tags-modal-list horizontal-options-list">
            {options.map((option, i) => {
              const isSelected = selectedValue === option.value;
              return (
                <Card className={`mb-2 mt-0 p-0 option-card-item ${isSelected ? "active-option" : ""}`} variant="outlined">
                  <CardContent className="p-0">
                    <ListItem
                      key={option.label}
                      button
                      className={`option-list-item ${isSelected ? "selected" : ""}`}
                      onClick={() => {
                        if (selectedValue === option?.value) return;
                        setSelectedValue(option.value)
                      }}
                    >
                      <input
                        type="checkbox"
                        className="heat_pump_checkbox hidden-checkbox"
                        name="switch_value"
                        value={option.value}
                        checked={isSelected}
                        readOnly
                        inputProps={{ "aria-labelledby": `switchValue-${option.value}` }}
                      />
                      <div className="option-content-wrapper">
                        {option.icon && <span className="option-icon">{option.icon}</span>}
                        <ListItemText
                          id={`switchValue-${option.value}`}
                          primary={<span className="option-label">{option.label}</span>}
                          className="text-center"
                        />
                      </div>
                    </ListItem>
                  </CardContent>
                </Card>
              )
            })}
          </List>
        </Grid>
      </DialogContent >

      {/* Action buttons */}
      <Grid>
        <DialogActions className="heat_pump_dialog_action">
          <Button
            className={`cus-btn-modal-submit ${isLoading[key] || !selectedValue?.toString() ? "disabled" : ""}`}
            onClick={isLoading[key] || !selectedValue?.toString() ? null : handleSubmit}>
            {isLoading[key] ? <CircularProgress size={18} color="white" /> : "Submit"}
          </Button>
        </DialogActions>
      </Grid>
    </>
  );
}
